import { ComicsList } from 'lib/comics';
/** styles **/
import s from '../../styles/organisms/comics.module.scss';
import classNames from 'classnames';

export const Comics: React.FC = () => {

  return (
    <div className={s.comicsContents}>
      {ComicsList.map((comic, index) => (
        <div key={index}>
          <div className={s.comicCase}>
            <span>CASE-0{ComicsList.length - index}</span>
            <p>{comic.type}</p>
          </div>

          <div className={s.comicListsWrapper}>
            <div className={classNames(s.comicListWrapper, s.nomal)}>
              <p className={s.label}>
                P-manのない生活
              </p>
              <div className={s.comicList}>
                {comic.nomalImages.map((image, imageindex) => (
                  <div className={s.imageWrapper} key={imageindex}>
                    <span>{imageindex + 1}</span>
                    <img key={index} src={require(`assets/images/${image}`)} alt={comic.type} />
                  </div>
                ))}
              </div>
            </div>
            <div className={s.comicListWrapper}>
              <p className={s.label}>P-manのある生活</p>
              <div className={s.comicList}>
                {comic.images.map((image, imageindex) => (
                  <div className={s.imageWrapper} key={imageindex}>
                    <span>{imageindex + 1}</span>
                    <img key={index} src={require(`assets/images/${image}`)} alt={comic.type} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
